import { apiBase } from "../utils/apiBase";

export const types = {
  ACTIVITIES_UNDONE_COUNT_SET: "ACTIVITIES_UNDONE_COUNT_SET",
  ACTIVITIES_WIDGET_SET_EXPANDED: "ACTIVITIES_WIDGET_SET_EXPANDED",
  ACTIVITIES_WIDGET_SET_ACTIVE_TAB: "ACTIVITIES_WIDGET_SET_ACTIVE_TAB",
  ACTIVITIES_WIDGET_SET_SELECTED_ID: "ACTIVITIES_WIDGET_SET_SELECTED_ID",
  ACTIVITIES_WIDGET_SET_LIST_FILTERS: "ACTIVITIES_WIDGET_SET_LIST_FILTERS",
  ACTIVITIES_WIDGET_SET_LIST_PAGE: "ACTIVITIES_WIDGET_SET_LIST_PAGE",
};

export const setUndoneCount = (value) => ({
  type: types.ACTIVITIES_UNDONE_COUNT_SET,
  value,
});

export const fetchUndoneActivityCount = () => async (dispatch) => {
  try {
    const res = await apiBase.get(`activities/undone-count`);
    const count = res.data?.count ?? 0;

    dispatch(setUndoneCount(count));
    return count;
  } catch {
    dispatch(setUndoneCount(0));
    return 0;
  }
};

export const setWidgetExpanded = (value) => ({
  type: types.ACTIVITIES_WIDGET_SET_EXPANDED,
  value,
});

export const setWidgetActiveTab = (value) => ({
  type: types.ACTIVITIES_WIDGET_SET_ACTIVE_TAB,
  value,
});

export const setSelectedActivityId = (value) => ({
  type: types.ACTIVITIES_WIDGET_SET_SELECTED_ID,
  value,
});

export const setListFilters = (value) => ({
  type: types.ACTIVITIES_WIDGET_SET_LIST_FILTERS,
  value,
});

export const setListPage = (value) => ({
  type: types.ACTIVITIES_WIDGET_SET_LIST_PAGE,
  value,
});

export const initialState = {
  undoneCount: 0,
  widget: {
    isExpanded: false,
    activeTab: "list",
    selectedActivityId: null,
    listFilters: { search: "", priority: null, status: "overdue" },
    listPage: 1,
  },
};

export function reducer(state = initialState, action) {
  const { type, value } = action;

  switch (type) {
    case types.ACTIVITIES_UNDONE_COUNT_SET:
      return { ...state, undoneCount: value };
    case types.ACTIVITIES_WIDGET_SET_EXPANDED:
      return { ...state, widget: { ...state.widget, isExpanded: value } };
    case types.ACTIVITIES_WIDGET_SET_ACTIVE_TAB:
      return { ...state, widget: { ...state.widget, activeTab: value } };
    case types.ACTIVITIES_WIDGET_SET_SELECTED_ID:
      return {
        ...state,
        widget: { ...state.widget, selectedActivityId: value },
      };
    case types.ACTIVITIES_WIDGET_SET_LIST_FILTERS:
      return {
        ...state,
        widget: {
          ...state.widget,
          listFilters: { ...state.widget.listFilters, ...value },
          listPage: 1,
        },
      };
    case types.ACTIVITIES_WIDGET_SET_LIST_PAGE:
      return { ...state, widget: { ...state.widget, listPage: value } };
    default:
      return state;
  }
}

const actions = {
  fetchUndoneActivityCount,
  setUndoneCount,
  setWidgetExpanded,
  setWidgetActiveTab,
  setSelectedActivityId,
  setListFilters,
  setListPage,
};

export default actions;
